import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { revertAll } from '../actions';

export interface ImpersonationState {
    isImpersonating: boolean;
    token: string | null;
    timeRemaining: {
        minutes: number;
        seconds: number;
    };
    showAttentionModal: boolean;
}

const initialState: ImpersonationState = {
    isImpersonating: false,
    token: null,
    timeRemaining: { minutes: 60, seconds: 0 },
    showAttentionModal: false,
};

const impersonationSlice = createSlice({
    name: 'impersonation',
    initialState,
    reducers: {
        setImpersonationToken: (state, action: PayloadAction<string | null>) => {
            return {
                ...state,
                token: action.payload,
                isImpersonating: !!action.payload,
            };
        },
        setImpersonating: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isImpersonating: action.payload,
            };
        },
        setShowAttentionModal: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                showAttentionModal: action.payload,
            };
        },
        updateTimeRemaining: (state, action: PayloadAction<{ minutes: number; seconds: number }>) => {
            return {
                ...state,
                timeRemaining: action.payload,
            };
        },
        setImpersonationState: (_state, action: PayloadAction<ImpersonationState>) => {
            return action.payload;
        },
        clearImpersonation: () => initialState,
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const {
    setImpersonationToken,
    setImpersonating,
    setShowAttentionModal,
    updateTimeRemaining,
    setImpersonationState,
    clearImpersonation,
} = impersonationSlice.actions;

export const impersonationReducer = impersonationSlice.reducer;
